/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { Route } from 'react-router';
import cx from 'classnames';

import RouteNames from '../../../appAuthorized/RouteNames';

import IconBackpack from '../../icons/IconBackpack';
import { useNotifications } from '../../../hooks/useNotifications';
import { useNavigate } from '../../../hooks/useNavigate';
import { useUIState } from '../../../hooks/useUIState';
import { useUserProfile } from '../../../hooks/useProfile';

interface Props {
  className?: string;
}
const NotificationsButton: React.FC<Props> = (props) => {
  const [{ notificationCount }] = useNotifications();
  const [, navActions] = useNavigate();
  const [{ isActiveProfileMainProfile }, uiActions] = useUIState();
  const [{ profileId }] = useUserProfile();

  return (
    <Route path={RouteNames.notifications()}>
      {
        ({ match }) => (
          <div>
            <div
              className={cx('cmp-notificationsbutton-wrapper', props.className)}
              onClick={() => {
                if (!isActiveProfileMainProfile) {
                  uiActions.setActiveProfile(profileId);
                }
                navActions.goTo(RouteNames.notifications());
              }}
            >
              <div
                className={cx('cmp-appnavnotificationsbutton border-color-profile-highlight', { 'bkgd-color-gsLightest': match })}
                style={{ borderRadius: '50%', border: '1px solid', width: 40, height: 40 }}
              >
                <div style={{ position: 'relative' }}>
                  { !!notificationCount && <div className="count profile-background-color-highlight">{notificationCount}</div> }

                  <IconBackpack color={match ? 'profile' : 'white'} size="21" />
                </div>
              </div>
            </div>
          </div>
        )
      }
    </Route>
  );
};

export default NotificationsButton;
